<div class="floating-textarea" [class.has-value]="control().value">
  <label class="floating-textarea__label">{{ label() }}</label>
  <textarea
    class="floating-textarea__field"
    [formControl]="control()"
    cdkTextareaAutosize
    [cdkAutosizeMinRows]="minRows()"
    [cdkAutosizeMaxRows]="expandable() ? undefined : maxRows()"
  ></textarea>
</div>
<div class="floating-textarea__error">
  <ng-content />
</div>
